const DEFAULT_BUTTON_NUMBER = 1;

const parsePresetVariable = (variable) => {
  // Find the first occurrence of a number
  const number = variable.match(/\d+/);
  return number ? parseInt(number[0], 10) : DEFAULT_BUTTON_NUMBER;
};

const getPrimaryButtonNumberFromPreset = (preset) => {
  if (!preset) return DEFAULT_BUTTON_NUMBER;

  const { variables } = preset;
  return parsePresetVariable(variables.primaryButtonBackgroundColor);
};

const getSecondaryButtonNumberFromPreset = (preset) => {
  if (!preset) return DEFAULT_BUTTON_NUMBER;

  const { variables } = preset;
  return parsePresetVariable(variables.secondaryButtonBackgroundColor);
};

export const getPrimaryButtonVariableNames = (activeButtonPreset = null) => {
  const primaryButtonNumber = getPrimaryButtonNumberFromPreset(activeButtonPreset);

  const variableNames = {
    PRIMARY_BUTTON_BACKGROUND: `primary_button_${primaryButtonNumber}_background`,
    PRIMARY_BUTTON_TEXT: `primary_button_${primaryButtonNumber}_text`,
    PRIMARY_BUTTON_BORDER: `primary_button_${primaryButtonNumber}_border`,
  };

  const variableVariants = {
    [variableNames.PRIMARY_BUTTON_BACKGROUND]: {
      HOVER: `primary_button_${primaryButtonNumber}_hover_background`,
      ACTIVE: `primary_button_${primaryButtonNumber}_active_background`,
      DISABLED: `primary_button_${primaryButtonNumber}_disabled_background`,
    },
    [variableNames.PRIMARY_BUTTON_TEXT]: {
      HOVER: `primary_button_${primaryButtonNumber}_hover_text`,
      ACTIVE: `primary_button_${primaryButtonNumber}_active_text`,
      DISABLED: `primary_button_${primaryButtonNumber}_disabled_text`,
    },
    [variableNames.PRIMARY_BUTTON_BORDER]: {
      HOVER: `primary_button_${primaryButtonNumber}_hover_border`,
      ACTIVE: `primary_button_${primaryButtonNumber}_active_border`,
      DISABLED: `primary_button_${primaryButtonNumber}_disabled_border`,
    },
  };

  return [variableNames, variableVariants];
};

export const getSecondaryButtonVariableNames = (activeButtonPreset = null) => {
  const secondaryButtonNumber = getSecondaryButtonNumberFromPreset(activeButtonPreset);

  const variableNames = {
    SECONDARY_BUTTON_BACKGROUND: `secondary_button_${secondaryButtonNumber}_background`,
    SECONDARY_BUTTON_TEXT: `secondary_button_${secondaryButtonNumber}_text`,
    SECONDARY_BUTTON_BORDER: `secondary_button_${secondaryButtonNumber}_border`,
  };

  const variableVariants = {
    [variableNames.SECONDARY_BUTTON_BACKGROUND]: {
      HOVER: `secondary_button_${secondaryButtonNumber}_hover_background`,
      ACTIVE: `secondary_button_${secondaryButtonNumber}_active_background`,
      DISABLED: `secondary_button_${secondaryButtonNumber}_disabled_background`,
    },
    [variableNames.SECONDARY_BUTTON_TEXT]: {
      HOVER: `secondary_button_${secondaryButtonNumber}_hover_text`,
      ACTIVE: `secondary_button_${secondaryButtonNumber}_active_text`,
      DISABLED: `secondary_button_${secondaryButtonNumber}_disabled_text`,
    },
    [variableNames.SECONDARY_BUTTON_BORDER]: {
      HOVER: `secondary_button_${secondaryButtonNumber}_hover_border`,
      ACTIVE: `secondary_button_${secondaryButtonNumber}_active_border`,
      DISABLED: `secondary_button_${secondaryButtonNumber}_disabled_border`,
    },
  };

  return [variableNames, variableVariants];
};
